export enum Platform {
  OVERVIEW = 'overview',
  GOOGLE = 'google',
  TIKTOK = 'tiktok',
  AMAZON = 'amazon',
  SHOPIFY = 'shopify',
  META = 'meta',
  LINKEDIN = 'linkedin',
  REDDIT = 'reddit',
  BING = 'bing',
}

export const PLATFORM_TITLE: Record<Platform, string> = {
  [Platform.OVERVIEW]: 'Overview',
  [Platform.META]: 'Meta',
  [Platform.GOOGLE]: 'Google',
  [Platform.TIKTOK]: 'TikToK',
  [Platform.AMAZON]: 'Amazon',
  [Platform.SHOPIFY]: 'Shopify',
  [Platform.LINKEDIN]: 'LinkedIn',
  [Platform.REDDIT]: 'Reddit',
  [Platform.BING]: 'Bing Ads',
};

export const PLATFORM_OPTIONS = (
  Object.keys(Platform) as (keyof typeof Platform)[]
).map((key) => {
  return {
    label: PLATFORM_TITLE[Platform[key]],
    value: Platform[key],
  };
});
